// contactColumns.ts
export const importType = [
    "Contact",
    "Intervention"
  ];
  